import { View } from 'react-native'
import styled from 'styled-components'
import Icon from '../../../../elements/images/Icon'
import { Text } from '../../../../elements/typography'

const BulletListItem = styled(View)`
  flex-direction: row;
  margin: ${(props) => props.theme.spacing.xxsmall}px 0;
`

const BulletIcon = styled(Icon).attrs((props) => ({
  color: props.theme.colors.grayLight,
  size: props.theme.fontSizes.larger,
}))`
  flex-grow: 0;
  margin-right: ${(props) => props.theme.spacing.small}px;
`

const BulletListText = styled(Text)`
  flex-grow: 1;
  color: ${(props) => props.theme.colors.grayDark};
  font-size: ${(props) => props.theme.fontSizes.small}px;
`

const BulletItem = ({ text, icon = 'check' }) => (
  <BulletListItem>
    <BulletIcon name={icon} />
    <BulletListText>{text}</BulletListText>
  </BulletListItem>
)

export const BulletList = ({ items, icon }) => (
  <View>
    {items.map((text, i) => (
      <BulletItem key={i} icon={icon} text={text} />
    ))}
  </View>
)
